import type { RouteLocationNormalizedLoaded } from 'vue-router';

/** Одна идентичность для кеша страницы и активности её обработчиков. */
export function workbookTabKey(route: Pick<RouteLocationNormalizedLoaded, 'name' | 'params'>): string | null {
  if (route.name === 'grid' || route.name === 'candidate') return 'grid';
  if (route.name === 'sheet' && route.params.code) return `sheet:${String(route.params.code)}`;
  return null;
}
